
import '../../styles/CAS.css';

/*Iconos*/
import Casco_icon from '../../imagenes/icons/casco.gif';
import Bases_icon from '../../imagenes/icons/bases.gif';
import Anexos_icon from '../../imagenes/icons/anexos.gif';
import Comunicado_icon from '../../imagenes/icons/comunicado.gif';
import FeErratas_icon from '../../imagenes/icons/feErratas.gif';
import EvaCV_icon from '../../imagenes/icons/evaluacion.gif';
import Entrevista_icon from '../../imagenes/icons/entrevista.gif';
import ResultFinal_icon from '../../imagenes/icons/resultados.gif';

/*Documentos*/
import Bases_pdf from '../../documentos/CAS/CASII2025/BASES_CAS_II_2025.pdf';
import Anexos_doc from '../../documentos/CAS/CASII2025/ANEXOS.docx';
import Comunicado_pdf from '../../documentos/CAS/CASII2025/COMUNICADO_CAS_II_2025.pdf';
import Fe_Erratas_pdf from '../../documentos/CAS/CASII2025/FE_DE_ERRATAS_02_2025.pdf';
import Result_CV_pdf from '../../documentos/CAS/CASII2025/RESULTADOS_DE_EVALUACION_CURRICULAR_02_2025.pdf';
import Cronograma_pdf from '../../documentos/CAS/CASII2025/CRONOGRAMA_DE_ENTREVISTA_02_2025.pdf';
import ResultFinal_pdf from '../../documentos/CAS/CASII2025/RESULTADOS_FINALES_CAS_02_2025.pdf';

function CASII2025(){
  const documentos=[
    {
      titulo: 'Bases Convocatoria II CAS 2025',
      icon: Bases_icon,
      nombre: 'Ver Documento',
      url: Bases_pdf,
    },
    {
      titulo: 'Anexos',
      icon: Anexos_icon,
      nombre: 'Ver Anexos',
      url: Anexos_doc,
    },
    {
      titulo: 'Comunicado N° 001',
      icon: Comunicado_icon,
      nombre: 'Ver Comunicado',
      url: Comunicado_pdf,
    },
    {
      titulo: 'Resultados Evaluación Curricular',
      icon: EvaCV_icon,
      nombre: 'Ver Resultados',
      url: Result_CV_pdf,
    },
    {
      titulo: 'Fe Erratas N° 002',
      icon: FeErratas_icon,
      nombre: 'Ver Publicación',
      url: Fe_Erratas_pdf,
    },
    {
      titulo: 'Cronograma Entrevistas Personales',
      icon: Entrevista_icon,
      nombre: 'Ver Cronograma',
      url: Cronograma_pdf,
    },
    {
      titulo: 'Resultados Finales',
      icon: ResultFinal_icon,
      nombre: 'Ver Resultados',
      url: ResultFinal_pdf,
    },
  ];
  return(
    <section className='cas-section'>
      <div className='titulo-cas'>
        <img src={Casco_icon} className='titulo-icon'></img>
        <h2>CAS Nº002-2025-MPCH</h2>
      </div>
      <p className='subtitulo'>Bases del Concurso para Contratación de Personal</p>
      <div className='cas-grid'>
        {documentos.map((doc, index) => (
          <div className='cas-card' key={index}>
            <img src={doc.icon} className='doc-icon'></img>
            <h3>{doc.titulo}</h3>
            <a
            href={doc.url}
            target="_blank"
            rel="noopener noreferrer"
            >
            {doc.nombre}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};
export default CASII2025;